import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Params, RouterLinkWithHref } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GtmDirective } from '../../directives/gtm/gtm.directive';
import { NotDraggableContentDirective } from '../../directives/not-draggable-content/not-draggable-content.directive';
import { BannerType } from './banner.model';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    GtmDirective,
    TranslateModule,
    NotDraggableContentDirective,
    MatIconModule,
    RouterLinkWithHref,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerComponent {
  @Input() linkForRouter?: string | string[];
  @Input() queryParams?: Params;
  @Output() clickEvent = new EventEmitter<void>();

  @Input() link?: string;
  @Input() linkLabel: string;
  @Input() linkGtm?: string;
  @Input() linkGtmAction?: string;
  @Input() linkGtmCategory?: string;
  @Input() linkInNewLine?: boolean;

  @Input() type: BannerType | 'info' | 'warning' | 'error' | 'success' = BannerType.warning;
  @Input() size: 'regular' | 'thin' = 'regular';
  @Input() icon = true;
  @Input() title?: string;

  onClick(): void {
    this.clickEvent.emit();
  }
}
